// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-page .audit-refresh {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.audit-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px 20px;
  margin-bottom: 20px;
  padding: 16px 18px;
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
}

.audit-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  color: #a1a1aa;
}

.audit-filter input,
.audit-filter select {
  min-width: 140px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #0a0a0a;
  color: #f4f4f5;
  font-size: 14px;
}

.audit-filter-apply {
  align-self: flex-end;
  margin-left: auto;
}

.audit-page-hint {
  margin: 0;
  font-size: 13px;
  color: #9ca3af;
  font-weight: 400;
}

.audit-table-wrap {
  overflow-x: auto;
  max-width: 100%;
}

.audit-table th,
.audit-table td {
  vertical-align: top;
  font-size: 13px;
}

.audit-cell-nowrap {
  white-space: nowrap;
}

.audit-cell-email {
  max-width: 200px;
  word-break: break-word;
}

.audit-cell-mono {
  font-family: ui-monospace, monospace;
  font-size: 12px;
}

.audit-payload {
  display: block;
  max-width: 280px;
  font-family: ui-monospace, monospace;
  font-size: 11px;
  color: #a1a1aa;
  word-break: break-word;
}

.audit-empty {
  text-align: center;
  padding: 28px 16px !important;
}

.audit-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
}

.audit-pill--ok {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.audit-pill--fail {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.audit-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px;
  border-top: 1px solid #374151;
  background: #0a0a0a;
}

.audit-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #374151;
  background: #1a1a1a;
  color: #f4f4f5;
  cursor: pointer;
}

.audit-page-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.audit-page-btn:not(:disabled):hover {
  border-color: #a61b34;
  color: #fff;
}

.audit-page-info {
  font-size: 14px;
  color: #d4d4d8;
  min-width: 56px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserAuditPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".audit-page .audit-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.audit-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 16px 20px;\n  margin-bottom: 20px;\n  padding: 16px 18px;\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n}\n\n.audit-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.audit-filter input,\n.audit-filter select {\n  min-width: 140px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #0a0a0a;\n  color: #f4f4f5;\n  font-size: 14px;\n}\n\n.audit-filter-apply {\n  align-self: flex-end;\n  margin-left: auto;\n}\n\n.audit-page-hint {\n  margin: 0;\n  font-size: 13px;\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.audit-table-wrap {\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.audit-table th,\n.audit-table td {\n  vertical-align: top;\n  font-size: 13px;\n}\n\n.audit-cell-nowrap {\n  white-space: nowrap;\n}\n\n.audit-cell-email {\n  max-width: 200px;\n  word-break: break-word;\n}\n\n.audit-cell-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 12px;\n}\n\n.audit-payload {\n  display: block;\n  max-width: 280px;\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n  color: #a1a1aa;\n  word-break: break-word;\n}\n\n.audit-empty {\n  text-align: center;\n  padding: 28px 16px !important;\n}\n\n.audit-pill {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.audit-pill--ok {\n  background: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n}\n\n.audit-pill--fail {\n  background: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n.audit-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 16px;\n  border-top: 1px solid #374151;\n  background: #0a0a0a;\n}\n\n.audit-page-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid #374151;\n  background: #1a1a1a;\n  color: #f4f4f5;\n  cursor: pointer;\n}\n\n.audit-page-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.audit-page-btn:not(:disabled):hover {\n  border-color: #a61b34;\n  color: #fff;\n}\n\n.audit-page-info {\n  font-size: 14px;\n  color: #d4d4d8;\n  min-width: 56px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
